import React from "react";
import ImageSection from "../../components/common/ImageSection";
import { Ring_circle } from "../../helper/imageConstant";

const ShippingPolicy = () => {
  return (
    <>
      <ImageSection name={"Shipping Policy"} />
      <section className="relative p-4 my-5 lg:my-5 xl:pb-14 overflow-hidden fonts text-justify">
        <div className="lg:mx-20 xl:mx-24 2xl:mx-32 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-1 gap-8">
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Where AU Do We Deliver?
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  We deliver to all and any postal address around the world.
                  Courier companies do not deliver to P.O.Box address, so we
                  request you to provide full street address with pin code / zip
                  code.
                </li>
                <li>
                  Please note that residential shipments to USA a some other
                  countries will be left at door if someone is not there to
                  receive the package or no one answers the doorbell. Our
                  courier agents LISPS / DHL / FEDEX / TNT / UPS / Speed Post
                  etc. will not be able to provide sign confirmation of delivery
                  made in such cases.
                </li>
                <li>
                  To ensure that no disputes arise due to this, kindly make sure
                  that someone is there to receive the package when courier
                  delivery is attempted.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Shipping -Cost{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Shipping cost is not built in each items price. You get the
                  benefit of reduced shipping cost on each additional item. Fair
                  Et transparent shipping rates.
                </li>
                <li>
                  Please also note that the shipping rates are weight based. The
                  weight of any product can be found on its detail page. To
                  match the policies of the shipping companies we use, all
                  weights will be rounded up to the next 500 grams.
                </li>
                <li>
                  International shipping and handling rates is based on the size
                  of your order: the larger your order, the lower the rate.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Shipping in India{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  We take great pride in being able to offer FREE SHIPPING to
                  any address in India to ensure quick delivery. Please be sure
                  to include the complete postal address with the correct PIN
                  code. We cannot be responsible for postal delays resulting
                  from incomplete address listings.
                </li>
                <li>
                  Also be aware that all shipments to any Girls
                  College/School/Hostel are placed at the customer's risk. If
                  the school's warden does not accept your package or it is
                  refused for any reason, Vikas Fashion will under no
                  circumstances issue a refund or credit to the customer's
                  account, nor shall Vikas Fashion attempt re-shipment of the
                  same order. For a special or preferred delivery date, the
                  buyer must mention the delivery date when placing their order.
                  If the order does not contain any delivery date, then it will
                  be delivered at the first opportunity, as soon as possible.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium ">
                Transit Times{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  We ship all orders by fastest possible courier services like
                  USPS, DHL, TNT, Speed Post etc.
                </li>
                <li>
                  On request, we can also make special quotes for shipping if
                  the merchandise order amount is large. Please write on
                  info@vikasfashion.com, for more details. If you ordered two or
                  more items, you may receive them in multiple boxes on
                  different days, because of varying item availability and
                  shipping locations. Often, products will be shipped separately
                  from one another for added safety in transit, so you may
                  receive more than one delivery to your address.
                </li>
                <li>
                  Please note that all the products will be shipped from India.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Transit Risk{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Vikas Fashion ships all parcels as fully insured at no extra
                  cost to customers. If courier company fails to deliver, you do
                  not suffer any loss. In-transit risk is all ours. But Vikas
                  Fashion will not responsible for lost and stolen packages or
                  any full or partial damages to the package after being left at
                  customer's address by postal / courier agency.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Address Change Requests 6{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Once an order is registered, you cannot make any changes.
                  However, address change requests may be accommodated within 24
                  hours of placing the order. You may send your address change
                  request to info@vikasfashion.com and the needful will be done.
                  Don’t forget to write your order no while placing the request.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Incorrect or Incomplete Address
              </h1>
              <ol className="list-decimal pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Please note: some courier companies charge a penalty for
                  incorrect shipping addresses, wherein the address and zip code
                  do not match. The customer will, without exception, bear the
                  cost of any such penalties and/or fees. Please make sure your
                  shipping address is correct.
                </li>
                <li>
                  In the event of a reshipment of the same order, customers will
                  be responsible to pay re-shipping charges for the reshipment.
                </li>
              </ol>
            </div>
            <div className="space-y-6">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                VAT / Custom Duties{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  VAT / Custom Taxes and Import Duties are not in our control.
                  They vary according to the rules of different countries and
                  must be paid directly by the buyer. VAT / Custom Taxes and
                  Import Duties are not included in our ordering process, but
                  may be charged to you by your government.
                </li>
                <li>
                  International customers are responsible for any customs or
                  duty fees levied by their country. We have no control over
                  these charges and cannot predict where they will occur, as
                  policies vary greatly from nation to nation.
                </li>
                <li>
                  They are entirely your responsibility. The courier company may
                  also charge some additional service charges over and above
                  custom duty on case to case basis.
                </li>
              </ul>
            </div>
            <div className="space-y-6">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Billing Address and Shipping Address{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Billing Address is the address where a customer gets his bills
                  from the credit card company. Shipping address is the address
                  where the customer wants to receive their shipment.
                </li>
              </ul>
            </div>
            <div className="space-y-6">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                What happens if my order is lost in transit?{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  If a shipment is lost in transit, we wait for 15 days and then
                  reprocess/reship the order. If you have any question about our
                  shipping pot ties, please email us at info@vikasfashion.com
                </li>
              </ul>
            </div>
            <div className="space-y-6">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Time to Ship{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Against each product on the website, an approximate time to
                  ship has been provided; which is merely indicative. Products
                  may be shipped either earlier or later depending on
                  availability of product and other factors. In Order to get an
                  accurate time to ship estimate, kindly email the order number
                  or item codes. As far as possible, orders shall be processed
                  within 48-72 hours of being placed with us. You can expect to
                  receive your order, on average, within 7-15 working days.
                </li>
              </ul>
            </div>
            <div className="space-y-6">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg font-medium">
                Tracking of Shipment{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Vikas Silk Mills shall provide details of shipment via email
                  alerts to the customer, once package is handed across to the
                  carrier agency. The email alerts shall contain the
                  transport/courier agency's website details along with tracking
                  number and expected date of delivery. The Customer may use the
                  said details to keep a check on status of the package.
                </li>
                <li>
                  You may also check your order status by logging into the ‘My
                  Account’ section of our site.
                </li>
                <li>
                  Please note that tracking numbers for orders shipped may take
                  up to 24 business hours to become active on the courier
                  websites.
                </li>
                <li>
                  In Case of Delays, Time to ship mentioned on our website
                  against each item is indicative and approximate values only
                  and sometimes due to situations beyond our control, delays may
                  occur. No refund, returns, replacement & exchange will be
                  entertained for this reason.
                </li>
                <li>
                  However some benefit might be given to customer on case to
                  case basis.
                </li>
                <li>
                  If for any reason, there is going to be a delay in shipping
                  because an item is out of stock or If there is an unusual
                  delay in filling an order, we will notify you by e-mail.
                </li>
                <li>
                  However any dates for delivery are approximate only and we are
                  not liable for any delay in delivering your order or any part
                  of it.
                </li>
                <li>
                  We may choose to deliver your order in separate parts. In some
                  cases we may offer to refund you for unfulfilled part of the
                  order.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="hidden lg:block absolute lg:bottom-[50%] lg:-right-[8%] xl:-right-[8%] 2xl:-right-[9%] 3xl:bottom-[50%] 3xl:-right-[8%]">
          <div className="lg:w-36 xl:w-44 2xl:w-60 3xl:w-64 h-full">
            <img src={Ring_circle} alt="" className="object-cover" />
          </div>
        </div>
      </section>
    </>
  );
};

export default ShippingPolicy;
